import Exception from 'app/errors/exception';

export default class InvalidArgumentException extends Exception
{
}
